module.exports = __webpack_public_path__ + "assets/img/n4.6c090ec5.png";